import moment from 'moment';
import {
  CONTRATO_STATUS_EM_ANALISE,
  CONTRATO_STATUS_EM_EDICAO,
} from '../../library/ContratoStatus';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_ADITIVO_NAME,
  CONTRATO_VERSAO_CONTRATO_NAME,
  CONTRATO_VERSAO_DISTRATO,
  CONTRATO_VERSAO_DISTRATO_NAME,
} from '../../library/ContratoVersoes';
import {
  formatToCurrency,
  getCurrencyNumberWithoutDecimal,
} from '../../utils/InputMaskUtils';
import { toRequest } from '../../utils/RequestUtils';
import { getApis } from './../../library/Apis';
import {
  contratoAlteraStatus,
  downloadDocumentoById,
  loadContratoArquivos,
} from './ContratosActions';
import { CONTENT_TYPE_PDF } from '../../utils/FileUtils';
import { CONTRATO_TIPO_ASSESSOR } from '../../library/ContratoTipos';

export const LOADING_CONTRATO_ASSESSOR_VIGENTE_ACTION =
  'LOADING_CONTRATO_ASSESSOR_VIGENTE_ACTION';
export const LOADED_CONTRATO_ASSESSOR_VIGENTE_ACTION =
  'LOADED_CONTRATO_ASSESSOR_VIGENTE_ACTION';
export const CLEARED_CONTRATO_ASSESSOR_ACTION =
  'CLEARED_CONTRATO_ASSESSOR_ACTION';
export const LOADED_CONTRATO_ASSESSOR_ACTION =
  'LOADED_CONTRATO_ASSESSOR_ACTION';
export const CHANGED_CONTRATO_ASSESSOR_EDITING_VALUE_ACTION =
  'CHANGED_CONTRATO_ASSESSOR_EDITING_VALUE_ACTION';
export const LOADING_CONTRATO_VALIDACAO = 'LOADING_CONTRATO_VALIDACAO';
export const LOADED_CONTRATO_VALIDACAO = 'LOADED_CONTRATO_VALIDACAO';
export const LOADING_CONTRATO_ASSESSOR_HISTORICO_ANALISE_OPERACIONAL =
  'LOADING_CONTRATO_ASSESSOR_HISTORICO_ANALISE_OPERACIONAL';
export const LOADED_CONTRATO_ASSESSOR_HISTORICO_ANALISE_OPERACIONAL =
  'LOADED_CONTRATO_ASSESSOR_HISTORICO_ANALISE_OPERACIONAL';
export const LOADING_CONTRATO_ASSESSOR_ALTERA_STATUS_ACTION =
  'LOADING_CONTRATO_ASSESSOR_ALTERA_STATUS_ACTION';
export const LOADED_CONTRATO_ASSESSOR_ALTERA_STATUS_ACTION =
  'LOADED_CONTRATO_ASSESSOR_ALTERA_STATUS_ACTION';

export const LOADING_CONTRATO_ASSESSOR_ARQUIVOS =
  'LOADING_CONTRATO_ASSESSOR_ARQUIVOS';
export const LOADED_CONTRATO_ASSESSOR_ARQUIVOS =
  'LOADED_CONTRATO_ASSESSOR_ARQUIVOS';
export const CLEAR_COD_COOP_ACTION = 'CLEAR_COD_COOP_ACTION';

const getEndpoint = (version) => {
  return getApis().apis.contrato + 'v' + version;
};

export const loadContratoAssessorVigente = (
  codCoop,
  cpfAssessor,
  data,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_CONTRATO_ASSESSOR_VIGENTE_ACTION,
      payload: true,
    });
    toRequest(
      'post',
      [
        getEndpoint(1) + '/contrato/assessor/vigente',
        {
          codCoop,
          cpfAssessor,
          data,
        },
      ],
      'contratoVigente'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_CONTRATO_ASSESSOR_VIGENTE_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_CONTRATO_ASSESSOR_VIGENTE_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp.data);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_CONTRATO_ASSESSOR_VIGENTE_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const clearContratoAssessorEditing = () => ({
  type: CLEARED_CONTRATO_ASSESSOR_ACTION,
  payload: null,
});

export const clearCodCoopGenericForm = () => ({
  type: CLEAR_COD_COOP_ACTION,
  payload: null,
});

export const loadContratoAssessor = (
  id,
  versaoContrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    toRequest(
      'get',
      [`${getEndpoint(1)}/contrato/assessor/${id}/${versaoContrato}`],
      'contrato'
    ).then(
      (resp) => {
        let data = resp.data;
        data.dataInicio =
          data.dataInicio && data.dataInicio.length > 0
            ? moment(data.dataInicio, 'YYYY MM DD').format('DD-MM-YYYY')
            : '';
        data.dataFim =
          data.dataFim && data.dataFim.length > 0
            ? moment(data.dataFim, 'YYYY MM DD').format('DD-MM-YYYY')
            : '';
        data.dataDistrato =
          data.dataDistrato && data.dataDistrato.length > 0
            ? moment(data.dataDistrato, 'YYYY MM DD').format('DD-MM-YYYY')
            : '';

        data.valorAssessoria =
          data.valorAssessoria !== null
            ? formatToCurrency(data.valorAssessoria, ',')
            : null;

        data.valorFormacao =
          data.valorFormacao !== null
            ? formatToCurrency(data.valorFormacao, ',')
            : null;

        data.valorOutros =
          data.valorOutros !== null
            ? formatToCurrency(data.valorOutros, ',')
            : null;

        data.valorReuniao =
          data.valorReuniao !== null
            ? formatToCurrency(data.valorReuniao, ',')
            : null;

        data.valorReembolsoHospedagem =
          data.valorReembolsoHospedagem !== null
            ? getCurrencyNumberWithoutDecimal(
              data.valorReembolsoHospedagem,
              ','
            )
            : null;
        data.valorReembolsoAlimentacao =
          data.valorReembolsoAlimentacao !== null
            ? getCurrencyNumberWithoutDecimal(
              data.valorReembolsoAlimentacao,
              ','
            )
            : null;
        data.valorReembolsoDeslocamento =
          data.valorReembolsoDeslocamento !== null
            ? getCurrencyNumberWithoutDecimal(
              data.valorReembolsoDeslocamento,
              ','
            )
            : null;
        data.valorReembolsoPedagio =
          data.valorReembolsoPedagio !== null
            ? getCurrencyNumberWithoutDecimal(data.valorReembolsoPedagio, ',')
            : null;
        data.valorReembolsoOutros =
          data.valorReembolsoOutros !== null
            ? getCurrencyNumberWithoutDecimal(data.valorReembolsoOutros, ',')
            : null;
        data.reembolsoOutrosDescricao =
          data.reembolsoOutrosDescricao !== null
            ? data.reembolsoOutrosDescricao
            : null;
        dispatch(clearContratoAssessorEditing());
        dispatch({
          type: LOADED_CONTRATO_ASSESSOR_ACTION,
          payload: data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp.data);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const changeContratoAssessorEditingValue = (name, value) => {
  if (typeof value === 'string') {
    if (value.trim().length > 0) {
      return {
        type: CHANGED_CONTRATO_ASSESSOR_EDITING_VALUE_ACTION,
        payload: { name, value },
      };
    } else {
      return {
        type: CHANGED_CONTRATO_ASSESSOR_EDITING_VALUE_ACTION,
        payload: { name, value: '' },
      };
    }
  }
  return {
    type: CHANGED_CONTRATO_ASSESSOR_EDITING_VALUE_ACTION,
    payload: { name, value },
  };
};

export const loadContratoValidacao = (
  id,
  versaoContrato,
  tipoContrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_CONTRATO_VALIDACAO,
      payload: true,
    });
    toRequest(
      'get',
      [
        `${getEndpoint(
          1
        )}/macro/contrato/${id}/${versaoContrato}/${tipoContrato}`,
      ],
      'save'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_CONTRATO_VALIDACAO,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_CONTRATO_VALIDACAO,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_CONTRATO_VALIDACAO,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadHistoricoContratoAssessorAnaliseOperacional = (
  id,
  versaoContrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_CONTRATO_ASSESSOR_HISTORICO_ANALISE_OPERACIONAL,
      payload: true,
    });
    toRequest(
      'get',
      [
        `${getEndpoint(
          1
        )}/contrato/assessor/listar/analiseOperacional/${id}/${versaoContrato}`,
      ],
      'listaAnaliseOperacional'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_CONTRATO_ASSESSOR_HISTORICO_ANALISE_OPERACIONAL,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_CONTRATO_ASSESSOR_HISTORICO_ANALISE_OPERACIONAL,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_CONTRATO_ASSESSOR_HISTORICO_ANALISE_OPERACIONAL,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const contratoAssessorAlteraStatus = (
  id,
  versaoContrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch(
      contratoAlteraStatus(
        id,
        versaoContrato,
        LOADING_CONTRATO_ASSESSOR_ALTERA_STATUS_ACTION,
        LOADED_CONTRATO_ASSESSOR_ALTERA_STATUS_ACTION,
        callbackSuccess,
        callbackError
      )
    );
  };
};

export const contratoAssessorRegisterPreEtapa = (
  preEtapa,
  callbackSuccess,
  callbackError
) => {
  const newPreEtapa = {
    ...preEtapa,
  };
  return (dispatch) => {
    toRequest(
      'post',
      [`${getEndpoint(1)}/contrato/assessor/preCadastro`, newPreEtapa],
      'save'
    ).then(
      (resp) => {
        switch (newPreEtapa.versaoContrato) {
          case CONTRATO_VERSAO_ADITIVO:
            dispatch(
              changeContratoAssessorEditingValue('idAditivo', resp.data.id)
            );
            break;
          case CONTRATO_VERSAO_DISTRATO:
            dispatch(
              changeContratoAssessorEditingValue('idDistrato', resp.data.id)
            );
            break;
          default:
            dispatch(
              changeContratoAssessorEditingValue('idContrato', resp.data.id)
            );
            break;
        }
        callbackSuccess();
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const contratoAssessorSendAnaliseOperacional = (
  analiseOperacional,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    toRequest(
      'post',
      [
        `${getEndpoint(1)}/contrato/assessor/analiseOperacional`,
        analiseOperacional,
      ],
      'save'
    ).then(
      () => {
        if (analiseOperacional.htmlContrato) {
          dispatch(
            changeContratoAssessorEditingValue(
              'flgStatus',
              CONTRATO_STATUS_EM_EDICAO
            )
          );
        } else {
          dispatch(
            changeContratoAssessorEditingValue(
              'flgStatus',
              CONTRATO_STATUS_EM_ANALISE
            )
          );
        }
        dispatch(
          loadHistoricoContratoAssessorAnaliseOperacional(
            analiseOperacional.idContrato,
            analiseOperacional.versaoContrato
          )
        );
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

const gerarUrlComNomeVersao = (versaoContrato) => {
  let versaoContratoNome;

  switch (versaoContrato) {
    case 2:
      versaoContratoNome = CONTRATO_VERSAO_ADITIVO_NAME;
      break;
    case 3:
      versaoContratoNome = CONTRATO_VERSAO_DISTRATO_NAME;
      break;
    case 1:
    default:
      versaoContratoNome = CONTRATO_VERSAO_CONTRATO_NAME;
      break;
  }
  return `${getEndpoint(1)}/documento/${versaoContratoNome}/nao-assinado`;
};

export const gerarContratoNaoAssinado = (
  id,
  versaoContrato,
  tipoContrato,
  callbackSuccess,
  callbackError
) => {
  return () => {
    const url = gerarUrlComNomeVersao(versaoContrato);

    toRequest(
      'post',
      [
        url,
        {
          id,
          versaoContrato,
          tipoContratoId: tipoContrato,
        },
      ],
      'save'
    ).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const downloadContrato = (
  idDocumento,
  callbackProgress,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch(
      downloadDocumentoById(
        idDocumento,
        CONTENT_TYPE_PDF,
        callbackProgress,
        callbackSuccess,
        callbackError
      )
    );
  };
};

export const downloadValidacaoContrato = (
  id,
  versaoContrato,
  callbackProgress,
  callbackSuccess,
  callbackError
) => {
  return () => {
    toRequest(
      'get',
      [
        `${getEndpoint(
          1
        )}/documento/${versaoContrato}/${CONTRATO_TIPO_ASSESSOR}/${id}`,
        {
          onDownloadProgress: (event) => {
            if (typeof callbackProgress === 'function') {
              callbackProgress(event);
            }
          },
          responseType: 'arraybuffer',
          headers: {
            Accept: 'text/csv',
            'Access-Control-Allow-Headers':
              'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
          },
        },
      ],
      'download-material-pedagogico'
    ).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadContratoAssessorArquivos = (
  idContrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch(
      loadContratoArquivos(
        idContrato,
        LOADING_CONTRATO_ASSESSOR_ARQUIVOS,
        LOADED_CONTRATO_ASSESSOR_ARQUIVOS,
        callbackSuccess,
        callbackError
      )
    );
  };
};
